import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/**
 * Code-drawn product cover (graphite + signal orange). Stands in for rendered
 * mockups until the real Parkour Class-Ready covers are uploaded.
 */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-gold',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  return <div className={`relative aspect-[2/3] overflow-hidden rounded-[6px] border border-white/10 bg-gradient-to-br from-navy-mid via-navy to-navy-deep shadow-book ${className}`} data-id="element-38" data-mp="2o7hraiiyrqz8">
      <span className={`absolute inset-y-0 left-0 w-[7%] ${accent}`} aria-hidden="true" data-id="element-39" data-mp="2edr5jle81un8" />
      {/* Dotted trajectory arc — the pack's "flight path" symbol */}
      <svg viewBox="0 0 100 150" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-40" data-mp="24h5vglnchtcj">
        <path d="M18 128 Q 55 40 96 70" fill="none" stroke="#5B93E6" strokeOpacity="0.35" strokeWidth="1.6" strokeDasharray="2 4" strokeLinecap="round" data-id="element-41" data-mp="19b14yyw0o10e" />
      </svg>
      <div className="relative flex h-full flex-col justify-between py-[11%] pl-[16%] pr-[10%]" data-id="element-42" data-mp="ze696nr4oept">
        <div data-id="element-43" data-mp="14c7r35cti7zp">
          <p className={`font-bold uppercase tracking-[0.18em] text-gold ${sm ? 'text-[6.5px] sm:text-[7.5px]' : 'text-[9px]'}`} data-id="element-44" data-mp="14bxyrb4avoqu">
            {kicker}
          </p>
          {number && <p className={`mt-1 font-display font-bold leading-none text-gold/30 ${sm ? 'text-3xl sm:text-4xl' : 'text-5xl'}`} data-id="element-45" data-mp="1j0ue7t8os41h">
              {number}
            </p>}
        </div>
        <p className={`font-display font-bold uppercase leading-[0.95] text-chalk ${sm ? 'text-[12px] sm:text-[15px]' : 'text-[19px]'}`} data-id="element-46" data-mp="7juhmlfb331n">
          {title}
        </p>
        <div className="flex items-center gap-1.5" data-id="element-47" data-mp="2ebqyiuy27376">
          <span className="h-px flex-1 bg-gold/50" data-id="element-48" data-mp="29abe953ph0pu" />
          <span className={`whitespace-nowrap font-bold uppercase tracking-widest text-white/55 ${sm ? 'text-[5.5px] sm:text-[6.5px]' : 'text-[8px]'}`} data-id="element-49" data-mp="29co21yw5a5at">
            Parkour Class-Ready
          </span>
        </div>
      </div>
    </div>;
}